import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useListPeyments } from "./Hooks";
import Loading from "../../Components/Loading";
import { renderPrice, ToDateJalali } from "../../Utils/functions";
import { BsArrowRight } from "react-icons/bs";
import "./index.scss";
const List = () => {
  const { loading, data } = useListPeyments();
  const navigate = useNavigate();
  const renderModel = model => {
    switch (model) {
      case "Plan":
        return "خرید اشتراک";
      case "Ads":
        return "ثبت آگهی";
      case "AdsOption":
        return "خرید امکانات آگهی";
      default:
        return "-"
    }
    return {};
  };
  const renderstatus = status => {
    switch (status) {
      case "waittopey":
      case "abandoned":
        return {
          title: "پرداخت رها شده",
          status: "process",
          details: false,
        };
      case "success":
        return {
          title: "پرداخت موفق",
          details: true,
          status: "success",
        };
      case "error":
        return {
          title: "خطا در پرداخت",
          details: true,
          status: "error",
        };
    }
    return {};
  };
  const renderBody = () => {
    if (loading) {
      return (
        <div className="row">
          <Loading count={2} col={12} height={"350px"} />
        </div>
      );
    } else {
      if (data.data.length == 0) {
        return (
          <div className="empty">
            <img src={require("../../assets/images/empty.png")} />
            <p className="fs-12 mt-2 fw-500 text-center sad">
              تاکنون پرداختی نداشته اید
            </p>
          </div>
        );
      } else {
        return data.data.map((item, count) => {
          return (
            <div className="card-order">
              <div className="d-flex justify-content-between align-items-center">
                <p className="key-card-order">مبلغ پرداخت : </p>
                <p className="value-card-order">
                  {renderPrice(item.total_price)}
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="key-card-order">وضعیت : </p>
                <p className="value-card-order">
                  {renderstatus(item.status)["title"]}
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="key-card-order">وضعیت : </p>
                <p className="value-card-order">
                  {renderModel(item.model_order)}
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="key-card-order">تاریخ : </p>
                <p className="value-card-order">
                  {ToDateJalali(item.created_at)}
                </p>
              </div>
              {/* <div className="d-flex justify-content-end">
                <button className="btn btn-primary">مشاهده</button>
              </div> */}
            </div>
          );
        });

        return;
      }
    }
  };
  return (
    <>
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">پرداخت های من</p>
        </div>
      </header>
      <div className="container">
        <div className="row">
          <div className="col-12 mt-2">{renderBody()}</div>
        </div>
      </div>
    </>
  );
};

export default List;
